import type { Node } from '@tiptap/pm/model';

import { Node_Type } from './../ricos-schema/legacy/wix/rich_content/v1';
import type { onAtomicBlockFocus } from './../ricos-types';
import { TIPTAP_TYPE_TO_RICOS_TYPE } from './../tiptap-editor/consts';

const textContainers = [
  Node_Type.PARAGRAPH,
  Node_Type.CODE_BLOCK,
  Node_Type.HEADING,
  Node_Type.CAPTION,
];

export const invokeAtomicBlockFocus = ({
  selectedNodes,
  onAtomicBlockFocus,
}: {
  selectedNodes: Node[];
  onAtomicBlockFocus?: onAtomicBlockFocus;
}) => {
  const parentNodes =
    selectedNodes.length === 2 && selectedNodes[0].type.name.includes('FIGURE')
      ? [selectedNodes[1]]
      : selectedNodes.length === 1
      ? selectedNodes
      : selectedNodes.filter(node => textContainers.includes(node.type.name as Node_Type));

  if (parentNodes.length === 1 && parentNodes[0].isBlock) {
    const firstNode = parentNodes[0];
    const blockKey = firstNode.attrs.id;
    const type =
      TIPTAP_TYPE_TO_RICOS_TYPE[
        firstNode.type.name as $TSFixMeKey<typeof TIPTAP_TYPE_TO_RICOS_TYPE>
      ] || 'text';
    const data = firstNode.attrs;
    onAtomicBlockFocus?.({ blockKey, type, data });
  } else {
    onAtomicBlockFocus?.({
      blockKey: undefined,
      type: undefined,
      data: undefined,
    });
  }
};
